'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.getSid = exports.getUserid = exports.getScript = exports.handleCallNewsApp = exports.callNewsAPP = void 0;
var _base = require('../base/base'), _copyToClipboard = _interopRequireDefault(require('copy-to-clipboard')), _this = void 0;
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
}
function asyncGeneratorStep(e, o, t, n, i, c, r) {
    try {
        var a = e[c](r), s = a.value;
    } catch (e) {
        return void t(e);
    }
    a.done ? o(s) : Promise.resolve(s).then(n, i);
}
function _asyncToGenerator(a) {
    return function () {
        var e = this, r = arguments;
        return new Promise(function (o, t) {
            var n = a.apply(e, r);
            function i(e) {
                asyncGeneratorStep(n, o, t, i, c, 'next', e);
            }
            function c(e) {
                asyncGeneratorStep(n, o, t, i, c, 'throw', e);
            }
            i(void 0);
        });
    };
}
function _objectSpread(o) {
    for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {}, n = Object.keys(t);
        'function' == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function (e) {
            _defineProperty(o, e, t[e]);
        });
    }
    return o;
}
function _defineProperty(e, o, t) {
    return o in e ? Object.defineProperty(e, o, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[o] = t, e;
}
function _typeof(e) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
        return typeof e;
    } : function (e) {
        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
    })(e);
}
var ua = 'object' === ('undefined' == typeof navigator ? 'undefined' : _typeof(navigator)) ? navigator.userAgent.toLocaleLowerCase() : '', uaMsg = {
        isWhere: function (e) {
            return ua.match(e);
        },
        weixin: ua.match(/micromessenger/gi),
        isWeibo: ua.match(/weibo/i),
        QQ: ua.match(/qq\//),
        isAndroid: ua.match(/android/gi),
        isIos: ua.match(/iphone|ipod/gi),
        isIpad: ua.match(/ipad/gi),
        wxosEdition: function () {
            var e = /([1-9]?[0-9])_([0-9])/gi.exec(ua);
            return null != e && (_this.isIos || _this.isIpad) && 3 <= e.length ? e[1] : 0;
        }
    }, platForm = function () {
        return uaMsg.weixin ? 'inter|wx_' : uaMsg.QQ ? 'inter|qq_' : uaMsg.isWeibo ? 'inter|wb_' : 'inter|other_';
    }, oToS = function (e, o) {
        for (var t = [], n = 0, i = Object.keys(e); n < i.length; n++) {
            var c = i[n];
            e[c] && ('secretCallUp' !== c && 'gourl' !== c && 'noPrefixKind' !== c && ('kind' === c ? o ? t.push(''.concat(c, '=').concat(e[c])) : t.push(''.concat(c, '=').concat(platForm()).concat(e[c])) : t.push(''.concat(c, '=').concat(e[c]))));
        }
        return uaMsg.isAndroid && t.push('timeStamp='.concat(new Date().getTime())), t.join('&');
    }, isFirstEntry = !0, isCloseGuideFixed = function () {
        -1 === location.href.indexOf('weiboGuideFixed=1') && (location.href = ''.concat(location.href, '#weiboGuideFixed=1'));
        var e = document.querySelector('#guideFixed');
        e.addEventListener('click', function () {
            -1 !== location.href.indexOf('weiboGuideFixed=1') && e && history.back();
        }), isFirstEntry && (isFirstEntry = !1, window.addEventListener('hashchange', function () {
            var e = document.querySelector('#guideFixed');
            -1 === location.href.indexOf('weiboGuideFixed=1') && e && e.parentNode.removeChild(e);
        }));
    }, callNewsAPP = function (e, o) {
        var t = document.createElement('img'), n = ''.concat(decodeURIComponent(o.id), '&').concat(oToS({ kind: o.kind }));
        t.src = 'http://api.iclient.ifeng.com/shareArticle?type='.concat(o.type, '&id=').concat(encodeURIComponent(n)), t.id = 'coldImg', t.style.display = 'none', document.body.appendChild(t), setTimeout(function () {
            document.body.removeChild(t);
        }, 500);
        var i = 'wakeupiOS/'.concat(e.openPath || 'ifengnews'), c = e.download || 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1367873683475', r = e.downloadAd || '', a = e.ucStopover || 'https://ishare.ifeng.com/ucTransfer?', s = e.protocolApi || 'comifengnewsclient://call', d = e.domainApi || 'https://i.ifeng.com/', u = o.noPrefixKind || '', p = null;
        e.downloadAd && e.download && (p = !0);
        var l = 'object' === _typeof(o) ? '?'.concat(oToS(o, u)) : '', f = '';
        if (uaMsg.isWeibo)
            return setTimeout(function () {
                document.hidden || document.querySelector('body').insertAdjacentHTML('beforeend', '<section id="guideFixed" style="position: fixed;width: 100%;height: 100%;top: 0; left: 0;background: #ececec; z-index:99999;"><img style="width:100%" src ="http://p2.ifengimg.com/ifengimcp/pic/20190507/21ab0fc3fd400f8e387e_size58_w750_h1334.png"></secton>'), isCloseGuideFixed();
            }, 500), !1;
        if (uaMsg.isIos || uaMsg.isIpad) {
            if (o.secretCallUp && o.gourl)
                return _base.storage.getSession('calluped') ? location.href = o.gourl : (_base.storage.setSession('calluped', 1), setTimeout(function () {
                    location.href = ''.concat(d).concat(i, '/call').concat(l, '&gourl=').concat(encodeURIComponent(o.gourl), '&remind=1');
                }, 10)), !1;
            if (o.gourl)
                return location.href = ''.concat(d).concat(i, '/call').concat(l, '&gourl=').concat(encodeURIComponent(o.gourl), '&remind=1'), !1;
            if (uaMsg.weixin)
                return location.href = ''.concat(d).concat(i, '/call').concat(l, '&remind=1'), !1;
            if (uaMsg.QQ)
                return (0, _copyToClipboard.default)(s + l), location.href = ''.concat(d).concat(i, '/call').concat(l, '&remind=1'), !1;
            if (0 < ua.indexOf('ucbrowser') && -1 === ua.indexOf('baidubrowser'))
                return (0, _copyToClipboard.default)(s + l), f = s + l, location.href = c, !1;
            l.replace('?', '');
            f = ''.concat(d).concat(i, '/call').concat(l, '&remind=1'), setTimeout(function () {
                location.href = f;
            });
        } else {
            if (o.secretCallUp && o.gourl)
                return _base.storage.getSession('calluped') ? location.href = o.gourl : (_base.storage.setSession('calluped', 1), location.href = s + l, setTimeout(function () {
                    location.href = o.gourl;
                }, 1000)), !1;
            if (o.gourl)
                return location.href = s + l, setTimeout(function () {
                    location.href = o.gourl;
                }, 1000), !1;
            if (uaMsg.weixin || uaMsg.QQ)
                return (0, _copyToClipboard.default)(s + l), f = ''.concat(c, '&android_scheme=').concat(encodeURIComponent(s + l)), location.href = f, !1;
            f = (0 < ua.indexOf('ucbrowser') || 0 < ua.indexOf('u;')) && -1 === ua.indexOf('miuibrowser') && -1 === ua.indexOf('vivobrowser') && -1 === ua.indexOf('mqqbrowser') ? a + s + l : s + l, location.href = f, document.hasFocus() && p && setTimeout(function () {
                location.href = r;
            }, 150);
        }
    };
exports.callNewsAPP = callNewsAPP;
var handleCallNewsApp = function (e, o, t, n, i, c, r) {
    var a = 7 < arguments.length && void 0 !== arguments[7] ? arguments[7] : {}, s = 8 < arguments.length && void 0 !== arguments[8] ? arguments[8] : {}, d = 0 <= ["zmt","source","hotspotlist","hotspotnew"].indexOf(o), u = Object.assign({
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354553159819',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905',
            domainApi: 'https://api.iclient.ifeng.com/'
        }, s), p = 'https://nine.ifeng.com/GetNewsDocs', l = 'doc', f = '';
    'nodata' === e ? l = 'awake' : 'phvideo' === (l = o) || 'video' === l ? (l = 'phvideo', f = t) : 'vampire' === l ? (l = 'doc', f = ''.concat('https://api.iclient.ifeng.com/api_vampire_article_detail?gv=5.5.5&doc=1', '&aid=').concat(t)) : 'web' === l ? f = t : 'topic2' === l || 'topic' === l ? f = ''.concat('https://api.iclient.ifeng.com/TopicApiForCmpp', '?topicid=').concat(t, '&json=y') : 'topic3' === l ? f = ''.concat('https://nine.ifeng.com/newTopic', '?topicid=').concat(t, '&json=y') : (('short' === l || 'article' === l) && (l = 'doc'), f = ''.concat(p, '?aid=').concat(t)), callNewsAPP(_objectSpread({}, u), _objectSpread({
        type: l,
        kind: r || 'sf_downopen',
        ref: 'hotspotlist' === o ? t : encodeURIComponent(decodeURIComponent(location.href)),
        id: d ? t : encodeURIComponent(decodeURIComponent(f)),
        playState: 1,
        comment: i || '',
        userId: c || ''
    }, a));
};
exports.handleCallNewsApp = handleCallNewsApp;
var getScript = function () {
    var t = _asyncToGenerator(regeneratorRuntime.mark(function e(o, t) {
        return regeneratorRuntime.wrap(function (e) {
            for (;;)
                switch (e.prev = e.next) {
                case 0:
                    return e.next = 2, (0, _base.loadScript)(o, {
                        cache: !1,
                        reload: !1
                    });
                case 2:
                    t && t();
                case 3:
                case 'end':
                    return e.stop();
                }
        }, e);
    }));
    return function (e, o) {
        return t.apply(this, arguments);
    };
}();
exports.getScript = getScript;
var getUserid = function () {
    return _base.cookie.get('userid');
};
exports.getUserid = getUserid;
var getSid = function () {
    return _base.cookie.get('sid');
};
exports.getSid = getSid;